import React, { useContext, useState, useEffect } from "react";
import { MemberDetails } from "../../Contexts/MemberDetailContext";
import ConditionalLoader from "../../Components/ConditionalLoader";
import ImageSubstitute from "../../Components/ImageSubstitute";
import { useNavigate } from "react-router-dom";
import { postData } from "../../Utils/AxiosRequest";
import { API_PATHS } from "../../Utils/Constants/constants";
import CustomPopup from "../../Components/CustomPopup";

const MemberHome = () => {
  const { isLoading, memberDetails, matProfileCount, jobCount, error } =
    useContext(MemberDetails);
  const navigate = useNavigate();
  const reqProfileCount = memberDetails?.RequestedProfileCount || 0;

  // State for liked profiles modal
  const [showLikedProfilesModal, setShowLikedProfilesModal] = useState(false);
  const [likedProfiles, setLikedProfiles] = useState([]);
  const [isLoadingLikedProfiles, setIsLoadingLikedProfiles] = useState(false);
  const [likedProfilesError, setLikedProfilesError] = useState(null);

  // State for messages
  const [showMessagesModal, setShowMessagesModal] = useState(false);
  const [messages, setMessages] = useState([]);
  const [messagesError, setMessagesError] = useState(null);
  const [isLoadingMessages, setIsLoadingMessages] = useState(false);

  // State for selected profile
  const [selectedProfile, setSelectedProfile] = useState(null);

  // State for matrimonial profiles
  const [matrimonialProfiles, setMatrimonialProfiles] = useState([]);
  const [isLoadingMatrimonialProfiles, setIsLoadingMatrimonialProfiles] =
    useState(false);
  const [matrimonialProfilesError, setMatrimonialProfilesError] =
    useState(null);

  // const fetchLikedProfiles = async () => {
  //   setIsLoadingLikedProfiles(true);
  //   setLikedProfilesError(null);

  //   try {
  //     // Step 1: Fetch all matrimonial profiles
  //     const res = await postData(API_PATHS.filterMatrimonialProfile, {});

  //     const profiles = res.data.Response || [];

  //     // Step 2: For each profile, check if it's liked
  //     const likedProfilesPromises = profiles.map(async (profile) => {
  //       try {
  //         const likeRes = await postData(
  //           `${API_PATHS.GetMyLikeProfile}?MatrimonialId=${profile.MemberMatrimonial_Id}`,
  //           {}
  //         );
  //         return likeRes.data.Response || null;
  //       } catch (err) {
  //         console.error(
  //           `Error checking like status for profile ${profile.MemberMatrimonial_Id}:`,
  //           err
  //         );
  //         return null;
  //       }
  //     });

  //     // Wait for all like checks to complete
  //     const likedProfilesResults = await Promise.all(likedProfilesPromises);

  //     // Filter out null results and flatten the array if needed
  //     const likedProfiles = likedProfilesResults
  //       .filter((profile) => profile !== null)
  //       .flat();

  //     setLikedProfiles(likedProfiles);
  //     // console.log("Liked Profiles:", likedProfiles);
  //   } catch (err) {
  //     console.error("Error fetching liked profiles:", err);
  //     setLikedProfilesError(
  //       err.response?.data?.message || "Failed to load profiles"
  //     );
  //   } finally {
  //     setIsLoadingLikedProfiles(false);
  //   }
  // };

  const fetchLikedProfiles = async () => {
    setIsLoadingLikedProfiles(true);
    setLikedProfilesError(null);

    try {
      // Replace this with your actual member ID (e.g., from auth context or state)
      const memberId = memberDetails?.MemberId;

      // Call the new API
      const res = await postData(
        `${API_PATHS.GetProfileLikeByMe}?memberid=${memberId}`,
        {}
      );

      const allProfiles = res.data.Response || [];

      const likedProfiles = allProfiles.filter(
        (profile) => profile.IsLiked === true
      );

      setLikedProfiles(likedProfiles);
      // console.log("Liked Profiles:", likedProfiles);
    } catch (err) {
      console.error("Error fetching liked profiles:", err);
      setLikedProfilesError(
        err.response?.data?.message || "Failed to load profiles"
      );
    } finally {
      setIsLoadingLikedProfiles(false);
    }
  };

  // const fetchMatrimonialProfiles = async () => {
  //   setIsLoadingMatrimonialProfiles(true);
  //   setMatrimonialProfilesError(null);

  //   try {
  //     // Step 1: Fetch all matrimonial profiles
  //     const res = await postData(API_PATHS.filterMatrimonialProfile, {});
  //     const profiles = res.data.Response || [];

  //     // Step 2: For each profile, check if there are requests
  //     const profilesWithRequests = await Promise.all(
  //       profiles.map(async (profile) => {
  //         try {
  //           const messagesRes = await postData(
  //             `${API_PATHS.GetMyRequestedProfile}?MatrimonialId=${profile.MemberMatrimonial_Id}`,
  //             {}
  //           );

  //           return {
  //             ...profile,
  //             hasRequests: (messagesRes.data.Response || []).length > 0,
  //             requests: messagesRes.data.Response || [],
  //           };
  //         } catch (err) {
  //           console.error(
  //             `Error checking requests for profile ${profile.MemberMatrimonial_Id}:`,
  //             err
  //           );
  //           return {
  //             ...profile,
  //             hasRequests: false,
  //             requests: [],
  //           };
  //         }
  //       })
  //     );

  //     setMatrimonialProfiles(profilesWithRequests);

  //     const requestList = profilesWithRequests.filter(
  //       (profile) => profile.hasRequests
  //     );
  //     // Combine all requests from all profiles
  //     const allRequests = requestList.flatMap(
  //       (profile) => profile.requests || []
  //     );
  //     // console.log("Message", allRequests);
  //     setMessages(allRequests);
  //   } catch (err) {
  //     console.error("Error fetching matrimonial profiles:", err);
  //     setMatrimonialProfilesError(
  //       err.response?.data?.message || "Failed to load profiles"
  //     );
  //   } finally {
  //     setIsLoadingMatrimonialProfiles(false);
  //   }
  // };

  // const fetchMatrimonialProfiles = async () => {
  //   setIsLoadingMatrimonialProfiles(true);
  //   setMatrimonialProfilesError(null);

  //   try {
  //     const memberId = memberDetails?.MemberId;
  //     const response = await postData(
  //       `${API_PATHS.GetProfileRequestedByMe}?memberid=${memberId}`,
  //       {}
  //     );

  //     // Make sure response.data exists before accessing Response
  //     const requestedProfiles = response?.data?.Response || [];

  //     setMatrimonialProfiles(
  //       requestedProfiles.map((profile) => ({
  //         ...profile,
  //         hasRequests: true,
  //       }))
  //     );

  //     // Set messages to the array of requested profiles
  //     setMessages(requestedProfiles);
  //   } catch (err) {
  //     console.error("Error fetching requested profiles:", err);
  //     setMatrimonialProfilesError(
  //       err?.response?.data?.message || "Failed to load requested profiles"
  //     );
  //     // Ensure messages is always an array even on error
  //     setMessages([]);
  //   } finally {
  //     setIsLoadingMatrimonialProfiles(false);
  //   }
  // };

  const handleOpenLikedProfiles = () => {
    setShowLikedProfilesModal(true);
    // fetchLikedProfiles();
  };

  const handleOpenMessages = () => {
    setShowMessagesModal(true);
    // Find all profiles with requests
    // const profilesWithRequests = matrimonialProfiles.filter(
    //   (profile) => profile.hasRequests
    // );
    // // Combine all requests from all profiles
    // const allRequests = profilesWithRequests.flatMap(
    //   (profile) => profile.requests || []
    // );
    // setMessages(allRequests);
    setSelectedProfile(null); // No specific profile selected when opening from card
  };

  const handleCloseLikedProfiles = () => {
    setShowLikedProfilesModal(false);
  };

  const handleCloseMessages = () => {
    setShowMessagesModal(false);
  };

  const handleRequest = async (MemberMatrimonialRequestId, action) => {
    try {
      const status = action === "accept" ? "Accepted" : "Rejected";
      const RequestStatus = action === "accept";

      await postData(API_PATHS.UpdateProfileStatus, {
        MemberMatrimonialRequestId,
        RequestStatus,
        Status: status,
      });

      // Safely filter messages
      setMessages((prevMessages) =>
        (prevMessages || []).filter(
          (msg) => msg.MemberMatrimonialRequestId !== MemberMatrimonialRequestId
        )
      );

      // Safely filter matrimonial profiles
      setMatrimonialProfiles((prevProfiles) =>
        (prevProfiles || []).map((profile) => ({
          ...profile,
          requests: (profile.requests || []).filter(
            (req) =>
              req.MemberMatrimonialRequestId !== MemberMatrimonialRequestId
          ),
          hasRequests: (profile.requests || []).some(
            (req) =>
              req.MemberMatrimonialRequestId !== MemberMatrimonialRequestId
          ),
        }))
      );
    } catch (err) {
      console.error(`Error ${action}ing request:`, err);
      setMessagesError(`Failed to ${action} request. Please try again.`);
    }
  };

  useEffect(() => {
    if (memberDetails?.MemberId) {
      fetchLikedProfiles();
      // fetchMatrimonialProfiles();
    }
  }, [memberDetails?.MemberId]);

  return (
    <ConditionalLoader isLoading={isLoading} error={error}>
      <div className="active-membership-icon">
        <div className="row">
          <div className="col-sm-3 mb-3">
            <div className="color-card color-bg-1">
              <h2 className="main-title text-white">{matProfileCount}</h2>
              <h3
                className="sub-title text-white"
                onClick={() => navigate("/matrimonial/profiles")}
                style={{ cursor: "pointer" }}
              >
                Matrimonial Profiles
              </h3>
            </div>
          </div>
          <div className="col-sm-3 mb-3">
            <div className="color-card color-bg-2">
              <h2 className="main-title text-white">{jobCount}</h2>
              <h3
                className="sub-title text-white"
                onClick={() => navigate("/dashboard/jobs")}
                style={{ cursor: "pointer" }}
              >
                Approved Jobs
              </h3>
            </div>
          </div>
          <div className="col-sm-3 mb-3">
            <div
              className="color-card color-bg-3"
              onClick={handleOpenLikedProfiles}
              style={{ cursor: "pointer" }}
            >
              <h2 className="main-title text-white">
                {likedProfiles.length > 0 ? likedProfiles.length : "0"}
              </h2>
              <h3 className="sub-title text-white">Profiles You Liked</h3>
            </div>
          </div>
          <div className="col-sm-3 mb-3">
            <div
              className="color-card color-bg-4"
              onClick={() => navigate("/matrimonial/profiles")}
              style={{ cursor: "pointer" }}
            >
              <h2 className="main-title text-white">{reqProfileCount ?? 0}</h2>
              <h3 className="sub-title text-white">Requested Profile</h3>
            </div>
          </div>
        </div>
      </div>

      {/* Liked Profiles Modal */}
      <CustomPopup
        showModal={showLikedProfilesModal}
        closeModal={handleCloseLikedProfiles}
        heading="Profiles You've Liked"
      >
        <div className="p-3" style={{ minHeight: "300px" }}>
          {isLoadingLikedProfiles ? (
            <div className="text-center py-4">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : likedProfilesError ? (
            <div className="alert alert-danger">{likedProfilesError}</div>
          ) : likedProfiles.length > 0 ? (
            <div className="profile-details-container">
              {likedProfiles.map((profile) => (
                <div
                  key={profile.MemberMatrimonialResponseId}
                  className="mb-4 p-3 border rounded"
                >
                  <div className="row">
                    <div className="col-md-6">
                      <h5 className="text-primary mb-3">
                        <i className="bi bi-heart-fill text-danger me-2"></i>
                        Liked Profiles
                      </h5>
                      <div className="mb-2">
                        <strong>Name:</strong>{" "}
                        {`${profile.ProfileFirstName || ""} ${
                          profile.ProfileLastName || ""
                        }`.trim() || "Not available"}
                      </div>
                      <div className="mb-2">
                        <strong>Reciver Name:</strong>{" "}
                        {profile.RecieverName || "Not available"}
                      </div>
                      <div className="mb-2">
                        <strong>Sender Name:</strong>{" "}
                        {profile.SenderName || "Not available"}
                      </div>
                    </div>
                    {/* <div className="col-md-6">
                      <h5 className="text-primary mb-3">
                        <i className="bi bi-person-fill me-2"></i>
                        Your Information
                      </h5>
                      <div className="mb-2">
                        <strong>Name:</strong>{" "}
                        {profile.SenderName || "Not available"}
                      </div>
                      <div className="mb-2">
                        <strong>Email:</strong>{" "}
                        {profile.SenderEmail || "Not available"}
                      </div>
                    </div> */}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-4">
              <div className="mb-3">
                <i
                  className="bi bi-heart text-danger"
                  style={{ fontSize: "2.5rem" }}
                ></i>
              </div>
              <h5>No liked profiles found</h5>
              <button
                className="btn btn-primary mt-3"
                onClick={() => {
                  handleCloseLikedProfiles();
                  navigate("/matrimonial/profiles");
                }}
              >
                Browse Profiles
              </button>
            </div>
          )}
        </div>
      </CustomPopup>

      {/* Messages Modal */}
      <CustomPopup
        showModal={showMessagesModal}
        closeModal={handleCloseMessages}
        heading="Notification for Profile"
      >
        <div className="p-3" style={{ minHeight: "300px" }}>
          {isLoadingMessages ? (
            <div className="text-center py-4">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : messagesError ? (
            <div className="alert alert-danger">{messagesError}</div>
          ) : messages.length > 0 ? (
            <div className="message-details-container">
              {messages.map((message) => (
                <div
                  key={message.MemberMatrimonialRequestId}
                  className="mb-4 p-3 border rounded"
                >
                  <div className="row">
                    <div className="col-md-6">
                      <h5 className="text-primary mb-3">
                        <i className="bi bi-heart-fill text-danger me-2"></i>
                        Request
                      </h5>
                      <div className="mb-2">
                        <strong>Name:</strong>{" "}
                        {`${message.ProfileFirstName || ""} ${
                          message.ProfileLastName || ""
                        }`.trim() || "Not available"}
                      </div>
                      <div className="mb-2">
                        <strong>Reciver Name:</strong>{" "}
                        {message.RecieverName || "Not available"}
                      </div>
                      <div className="mb-2">
                        <strong>Sender Name:</strong>{" "}
                        {message.SenderName || "Not available"}
                      </div>
                      <div className="d-flex mt-3">
                        <button
                          onClick={() =>
                            handleRequest(
                              message.MemberMatrimonialRequestId,
                              "accept"
                            )
                          }
                          className="btn btn-success btn-sm"
                          style={{ marginRight: "12px" }}
                        >
                          Accept
                        </button>
                        <button
                          onClick={() =>
                            handleRequest(
                              message.MemberMatrimonialRequestId,
                              "reject"
                            )
                          }
                          className="btn btn-danger btn-sm"
                        >
                          Reject
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-4">
              <i className="bi bi-envelope-open fs-1 text-muted mb-3"></i>
              <p>No messages found for this profile</p>
            </div>
          )}
        </div>
      </CustomPopup>

      {/* Profile Information Section */}
      <div className="active-membership-dashboard">
        <div className="row">
          <div className="col-md-7 mb-3">
            <div className="membership-dashboard-detail">
              <h2 className="sub-title-2 mb-3">Profile Information</h2>
              <div className="profile-img">
                {memberDetails?.DisplayURL &&
                memberDetails.DisplayURL !==
                  `${process.env.REACT_APP_API_URL}/` ? (
                  <img src={memberDetails.DisplayURL} alt="" />
                ) : (
                  <ImageSubstitute name={memberDetails?.FirstName} />
                )}
              </div>
              <div className="view-member-profile-detail">
                <ul className="view-profile-list">
                  {memberDetails.FirstName && (
                    <li>
                      <strong>Name: </strong>{" "}
                      <span>
                        {(memberDetails.FirstName ?? "") +
                          " " +
                          (memberDetails.LastName ?? "")}{" "}
                      </span>
                    </li>
                  )}
                  {memberDetails.Gender && (
                    <li>
                      <strong>Gender: </strong>{" "}
                      <span>{memberDetails.Gender ?? ""}</span>
                    </li>
                  )}
                  {memberDetails.DOB && (
                    <li>
                      <strong>Date of Birth: </strong>{" "}
                      <span>
                        {memberDetails.DOB
                          ? new Date(memberDetails.DOB).toLocaleDateString(
                              "ta-IN"
                            )
                          : ""}
                      </span>
                    </li>
                  )}
                  {memberDetails.CurrentDesignation && (
                    <li>
                      <strong>Occupation: </strong>{" "}
                      <span>{memberDetails?.CurrentDesignation ?? ""}</span>
                    </li>
                  )}
                  {memberDetails?.State && (
                    <li>
                      <strong>Location: </strong>{" "}
                      <span>
                        {(memberDetails?.District ?? "") +
                          ", " +
                          (memberDetails?.State ?? "")}
                      </span>
                    </li>
                  )}
                  <li>
                    <strong>Email: </strong>{" "}
                    <span>{memberDetails?.Email ?? "N/A"}</span>
                  </li>
                  <li>
                    <strong>Phone Number: </strong>{" "}
                    <span>{memberDetails?.PhoneNumber ?? "N/A"}</span>
                  </li>
                  <li>
                    <strong>Nationality: </strong>{" "}
                    <span>{memberDetails?.Nationality ?? "N/A"}</span>
                  </li>
                  <li>
                    <strong>Profile ID: </strong>{" "}
                    <span>{memberDetails?.MemberUniqueId ?? "N/A"}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-md-5">
            <div className="membership-dashboard-detail mb-3">
              <h2 className="sub-title-2 mb-3">Membership Overview</h2>
              <div className="view-member-profile-detail">
                <ul className="view-profile-list">
                  <li>
                    <strong className="w-100">Current Plan: </strong>{" "}
                    <span className="w-100">Premium (Active) </span>
                  </li>
                  <li>
                    <strong className="w-100">Membership Start Date: </strong>{" "}
                    <span className="w-100">January 1, 2024</span>
                  </li>
                  <li>
                    <strong className="w-100">Membership Expiry Date: </strong>{" "}
                    <span className="w-100">December 31, 2024</span>
                  </li>
                </ul>
                <a href="/home" className="btn green-btn">
                  Upgrade/Downgrade Membership
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ConditionalLoader>
  );
};

export default MemberHome;
